const baseUrl = "/api/auth";

// 로그인
const loginApi = async (username: string, password: string): Promise<void> => {
  const { $axios } = useNuxtApp();
  return $axios.post(`${baseUrl}/login?username=${username}&password=${password}`);
}

// 로그아웃
const logoutApi = async (): Promise<void> => {
  const { $axios } = useNuxtApp();
  return await $axios.post(`${baseUrl}/logout`);
}



export {
  loginApi, logoutApi
};
